
// function updateIframeContent (iframeID, content) {
//   var iframe = document.getElementById(iframeID)
//   var iframeDoc
//   if (iframe.contentWindow) {
//     iframeDoc = iframe.contentWindow
//   } else if (iframe.contentDocument.document) {
//     iframeDoc = iframe.contentDocument.document
//   } else if (iframe.contentDocument) {
//     iframeDoc = iframe.contentDocument
//   } else {
//     alert('Cannot inject dynamic contents into iframe.')
//     return
//   }
//   iframeDoc.document.open()
//   iframeDoc.document.write(content)
//   iframeDoc.document.close()
//   $(iframe).parent().css('display', 'block')
//   window.Swal.hideLoading()
// }

export default (editor, config) => {
  const cm = editor.Commands
  const panels = editor.Panels
  const loadingPage = `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <title>预览准备中...</title>
    <style>
        .loader {
            background: #000;
            background: radial-gradient(#222, #000);
            bottom: 0;
            left: 0;
            overflow: hidden;
            position: fixed;
            right: 0;
            top: 0;
            z-index: 99999;
        }

        .loader-inner {
            bottom: 0;
            height: 60px;
            left: 0;
            margin: auto;
            position: absolute;
            right: 0;
            top: 0;
            width: 100px;
        }

        .loader-line-wrap {
            -webkit-animation: spin 2000ms cubic-bezier(.175, .885, .32, 1.275) infinite;
            animation: spin 2000ms cubic-bezier(.175, .885, .32, 1.275) infinite;
            box-sizing: border-box;
            height: 50px;
            left: 0;
            overflow: hidden;
            position: absolute;
            top: 0;
            -webkit-transform-origin: 50% 100%;
            transform-origin: 50% 100%;
            width: 100px;
        }

        .loader-line {
            border: 4px solid transparent;
            border-radius: 100%;
            box-sizing: border-box;
            height: 100px;
            left: 0;
            margin: 0 auto;
            position: absolute;
            right: 0;
            top: 0;
            width: 100px;
        }

        .loader-line-wrap:nth-child(1) {
            -webkit-animation-delay: -50ms;
            animation-delay: -50ms;
        }

        .loader-line-wrap:nth-child(2) {
            -webkit-animation-delay: -100ms;
            animation-delay: -100ms;
        }

        .loader-line-wrap:nth-child(3) {
            -webkit-animation-delay: -150ms;
            animation-delay: -150ms;
        }

        .loader-line-wrap:nth-child(4) {
            -webkit-animation-delay: -200ms;
            animation-delay: -200ms;
        }

        .loader-line-wrap:nth-child(5) {
            -webkit-animation-delay: -250ms;
            animation-delay: -250ms;
        }

        .loader-line-wrap:nth-child(1) .loader-line {
            border-color: hsl(0, 80%, 60%);
            height: 90px;
            width: 90px;
            top: 7px;
        }

        .loader-line-wrap:nth-child(2) .loader-line {
            border-color: hsl(60, 80%, 60%);
            height: 76px;
            width: 76px;
            top: 14px;
        }

        .loader-line-wrap:nth-child(3) .loader-line {
            border-color: hsl(120, 80%, 60%);
            height: 62px;
            width: 62px;
            top: 21px;
        }

        .loader-line-wrap:nth-child(4) .loader-line {
            border-color: hsl(180, 80%, 60%);
            height: 48px;
            width: 48px;
            top: 28px;
        }

        .loader-line-wrap:nth-child(5) .loader-line {
            border-color: hsl(240, 80%, 60%);
            height: 34px;
            width: 34px;
            top: 35px;
        }

        @-webkit-keyframes spin {
            0%,
            15% {
                -webkit-transform: rotate(0);
                transform: rotate(0);
            }
            100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
            }
        }

        @keyframes spin {
            0%,
            15% {
                -webkit-transform: rotate(0);
                transform: rotate(0);
            }
            100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
            }
        }
    </style>
</head>

<body>
    <div class="loader">
        <div class="loader-inner">
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
        </div>
    </div>

</body>

</html>`
  // let idCount = 0

  cm.add('code-editor', {
    run (editor) {
      // switch to code-editor.
      // alert(123)
      setTimeout(function () {
        editor.stopCommand('code-editor')
      }, 10)
    },
    stop () {
      // switch to graphics editor.
      panels.getButton('editor', 'code-editor').set('active', false)
      console.log('stop')
    }
  })

  cm.add('wwsave', {
    run (editor) {
      let Swal = window.Swal
      Swal.fire({
        title: '页面保存',
        html: '如果填写注释，则同时保存版本库，未来可以随时回滚到保存的版本。查看<a href="#" target="_blank">版本库的帮助</a>',
        input: 'textarea',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputPlaceholder: '修改:添加购买链接\n目的:可以购物\n提出人:张三',
        // showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (typeof result.value === 'string') {
          let wwInst = editor.wwinst
          let oldFlag = wwInst.setSyncFlag(true, result.value)
          editor.store((res) => {
            wwInst.setSyncFlag(oldFlag)
            if (res) {
              console.log('save finish with error:', res)
            }
            editor.stopCommand('wwsave')
          })
        } else if (typeof result.dismiss === 'string' && result.dismiss.length > 0) {
          editor.stopCommand('wwsave')
        }
      })
    },
    stop () {
      // switch to graphics editor.
      let but = panels.getButton('preview', 'wwsave')
      if (but) {
        console.log('stop wwsave')
        but.set('active', false)
      }
    }
  })

  cm.add('preview-desktop', {
    // run (editor) {
    //   console.log(`${editor.getHtml()}\n<style>${editor.getCss()}</style>`)
    //   let Swal = window.Swal
    //   let frameid = `previewFrame_${idCount++}`
    //   Promise.pipe([
    //     function () {
    //       Swal.fire({
    //         width: '100%',
    //         padding: '0',
    //         title: '<div>预览</div>',
    //         showCloseButton: true,
    //         closeButtonAriaLabel: wwjs.i18n('关闭预览'),
    //         grow: 'column',
    //         showConfirmButton: false,
    //         onAfterClose: function () {
    //           editor.stopCommand('preview-desktop')
    //         },
    //         onBeforeOpen: () => {
    //           Swal.showLoading()
    //         },
    //         html: `<style>
    //         .swal2-container{
    //           padding: 0px;
    //         }
    //         .swal2-popup{
    //           border-radius: 0px;
    //         }
    //         </style>
    //         <hr/>
    //         <div class="embed-responsive embed-responsive-21by9" style="display:none">
    //         <iframe id="${frameid}" class="embed-responsive-item" src="javascript:void(0);">
    //         </iframe>
    //         </div>`
    //       })
    //     },
    //     wwjs.net.run([`@/@wwcmd/wwcompiler/1.0.1/wwcompiler.min.js#build`, editor.getHtml(), {}, editor.getCss()]),
    //     function (content) {
    //       console.log(content)
    //       updateIframeContent(frameid, content.content)
    //     }
    //   ])
    // },
    run (editor) {
      let self = this
      editor.previewWindow = window.open('about:blank', 'previewWindow', 'address=0,toolbar=1')
      editor.previewWindow.document.open()
      editor.previewWindow.document.write(loadingPage)
      editor.previewWindow.document.close()
      editor.previewWindow.focus()
      if (editor.previewTimer) {
        clearInterval(editor.previewTimer)
      }
      editor.previewTimer = setInterval(function () {
        if (editor.previewWindow && editor.previewWindow.closed) {
          editor.previewWindow = null
          self.stopEffect(editor)
        }
      }, 1000)
      // console.log(editor.previewWindow.onbeforeunload)
      // editor.previewWindow.onbeforeunload = this.stopEffect.bind(this,editor)
      panels.getButton('preview', 'preview-desktop').set('active', true)
      let wwInst = editor.wwinst
      Promise.pipe([
        function () {
          let oldFlag = wwInst.setSyncFlag(false)
          return new Promise(function (resolve, reject) {
            wwInst.editor.store(function (err) {
              if (!oldFlag) {
                wwInst.setSyncFlag(oldFlag)
              }
              if (err) {
                reject(err)
              } else {
                resolve(true)
              }
            })
          })
        },
        function () {
          // console.log('wwInst.getLayers()=', JSON.stringify(wwInst.getLayers()))
          return wwjs.net.run([`@/@wwcmd/wwcompiler/1.0.1/wwcompiler.min.js#build`, wwInst.getLayers()])
        },
        function (content) {
          // console.log(content)
          editor.previewWindow.document.open()
          editor.previewWindow.document.write(content.content)
          editor.previewWindow.document.close()
          // console.log(editor.previewWindow.onbeforeunload)
        }
      ])
    },
    stopEffect (editor) {
      panels.getButton('preview', 'preview-desktop').set('active', false)
      if (editor.previewTimer) {
        clearInterval(editor.previewTimer)
        editor.previewTimer = null
      }
      // console.log('stop effect')
    },
    stop (editor) {
      // console.log(arguments)
      // console.log('run into stop')
      if (editor.previewWindow) {
        if (editor.previewWindow.closed) {
          this.stopEffect(editor)
        } else {
          // editor.previewWindow.close()
          // editor.previewWindow = null
          setTimeout(function () {
            editor.runCommand('preview-desktop')
          }, 10)
        }
      } else {
        this.stopEffect(editor)
      }
      // switch to graphics editor.
      // console.log('stop')
    }
  })
}
